var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:("" + (_vm.primaryButtons? 'btn': 'outlined')),attrs:{"elevation":"2","small":_vm.small,"x-large":_vm.xLarge,"fab":_vm.fab,"outlined":_vm.outlined,"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }